import React, { useState } from 'react';

import '@/assets/styles/components/students-filters.styles.scss';
import { CustomDatePicker } from '../datepicker/DatePicker.tsx';
import dayjs from 'dayjs';
import { useSizes } from '@/utility/responsive.ts';

export const StudentsFilters = ({ updateStudentFilters }: { updateStudentFilters: any }) => {
	const { isMobile } = useSizes();
	const [matchingDateFrom, setMatchingDateFrom] = useState<Date | null>(null);
	const [matchingDateTo, setMatchingDateTo] = useState<Date | null>(null);
	const [lastInteractionDateFrom, setLastInteractionDateFrom] = useState<Date | null>(null);
	const [lastInteractionDateTo, setLastInteractionDateTo] = useState<Date | null>(null);
	const [totalInteractionCount, setTotalInteractionCount] = useState<string>();

	const handleApplyFilters = () => {
		updateStudentFilters((prevState: any) => {
			return {
				...prevState,
				matchingDateFrom,
				matchingDateTo,
				lastInteractionDateFrom,
				lastInteractionDateTo,
				totalInteractionCount
			};
		});
	};

	return (
		<div className="students-filters">
			<div className="filter">
				<CustomDatePicker
					shouldCloseOnSelect={isMobile}
					withPortal={isMobile}
					onResetValue={() => {
						setMatchingDateFrom(null);
						setMatchingDateTo(null);
					}}
					minDate={dayjs().subtract(2, 'year').toDate()}
					maxDate={dayjs().toDate()}
					startDate={matchingDateFrom}
					endDate={matchingDateTo}
					label="Atanma Tarihi"
					selectsRange
					onChange={(dates: [Date | null, Date | null]) => {
						const [start, end] = dates;
						setMatchingDateFrom(start);
						setMatchingDateTo(end);
					}}
				/>
			</div>
			<div className="filter">
				<div className="meeting-count-input-wrapper">
					<label className="label-meeting-count">Görüşme Sayısı</label>
					<input
						type="text"
						className="input-meeting-count"
						placeholder="Örn: 10, 12, 5"
						value={totalInteractionCount}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTotalInteractionCount(e.target.value)}
					/>
				</div>
			</div>

			<div className="filter">
				<CustomDatePicker
					shouldCloseOnSelect={isMobile}
					withPortal={isMobile}
					onResetValue={() => {
						setLastInteractionDateFrom(null);
						setLastInteractionDateTo(null);
					}}
					minDate={dayjs().subtract(2, 'year').toDate()}
					maxDate={dayjs().toDate()}
					startDate={lastInteractionDateFrom}
					endDate={lastInteractionDateTo}
					label="Son Görüşme Tarihi"
					selectsRange
					onChange={(dates: [Date | null, Date | null]) => {
						const [start, end] = dates;
						setLastInteractionDateFrom(start);
						setLastInteractionDateTo(end);
					}}
				/>
			</div>

			<div className="action">
				<button
					className="btn-filter"
					onClick={handleApplyFilters}>
					Filtrele
				</button>
			</div>
		</div>
	);
};
